import React from 'react';
import {
  Button,
  ListItemIcon,
  MenuItem,
  SettingsIcon,
} from '@cherre-frontend/ui';

interface ConfigureCustomAttributesButtonProps {
  variant: 'button' | 'menu-item';
  onClick: () => void;
}

const buttonLabel = 'Configure Attributes';

export const ConfigureCustomAttributesButton = ({
  variant,
  onClick,
}: ConfigureCustomAttributesButtonProps) => {
  if (variant === 'button') {
    return (
      <Button
        variant='contained'
        color='primary'
        sx={{ marginTop: '12px' }}
        startIcon={<SettingsIcon />}
        onClick={onClick}
      >
        {buttonLabel}
      </Button>
    );
  }

  return (
    <MenuItem onClick={onClick}>
      <ListItemIcon>
        <SettingsIcon />
      </ListItemIcon>
      {buttonLabel}
    </MenuItem>
  );
};
